<script>
  import Buttons from './components/Buttons.svelte';
  import SeasonalItem from './components/SeasonalItem.svelte';
  import data from './lib/seasonal.json';


  let view = 'co2';
  const options = [
    { label: 'CO₂', value: 'co2' },
    { label: 'Preis', value: 'price' },
    { label: 'Preis pro Kilo CO₂', value: 'price_for_co2' },
  ];


  const valueUnits = {
    co2: 'kg',
    price: '€',
    //'price_for_co2': '€ pro Kilo CO₂',
    'price_for_co2': '€',
  };

</script>



<div class="seasonal">
  <div class="seasonal-toggle">
    <Buttons bind:value={view} {options} />
  </div>

  <div class="seasonal-content">

    {#each data as d, i }
      <SeasonalItem
        name={d.name}
        icon={d.id}
        unit={d.unit}
        avg={d[view].avg}
        months={d[view].months}
        animated={true}
        showMonthsTop={i===0}
        showMonthsBottom={i===data.length - 1}
        valueUnit={valueUnits[view]}
      />
    {/each}


  </div>
</div>


<style>
  .seasonal {
    background-color: #dedede;
    border-radius: 6px;
    font-family: "Franklin Gothic FS", Helvetica, Arial, sans-serif;
    font-size: 16px;
    line-height: 24px;
    overflow: hidden;
  }

  .seasonal-content {
    padding: 35px 15px 35px 15px;
  }

  .seasonal-toggle {
    background: #ededed;
    padding: 20px 0 20px;
  }


  @media (max-width: 480px) {
    .seasonal {
      font-size: 14px;
      line-height: 17px;
    }

    .seasonal-content {
      padding: 25px 10px 25px 10px;
    }
  }
</style>
